// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__SQcIx","messages":"Chat_messages__3VegG","dateDivider":"Chat_dateDivider__2-EJj"};